import React, { Fragment } from 'react';
import { Button, UncontrolledTooltip } from 'reactstrap';
export default function CustomEditButton(props){  
    const {keyvalue} = props;  
    return(
        <Fragment>
            <Button className='action-btn' color='info' id={`tooltip_edit_key_${keyvalue}`} {...props}>
                <span className='fas fa-pencil-alt'></span>
            </Button>
            <UncontrolledTooltip placement="top" target={`tooltip_edit_key_${keyvalue}`}>
                Edit
            </UncontrolledTooltip>
        </Fragment>
    );
}